import { Controller } from "@hotwired/stimulus"

// Rewrites a server-rendered time in the reader's own zone.
//
// The server runs on UTC and has no way to know better — there is no timezone
// on a user or an account. The browser does know, so the element arrives
// carrying the instant in `datetime` and the server's UTC rendering as its
// text, and this replaces the text with the same moment in the zone the reader
// is actually in. Without JavaScript the UTC rendering stands, which is wrong
// by hours but never blank.
//
// See app/helpers/application_helper.rb and
// spec/system/times_are_the_readers_own_spec.rb.
export default class extends Controller {
  static values = { format: String }

  // Matches the server's strftime formats so the text does not jump when this
  // takes over. 24-hour, because that is what the product already showed.
  static PARTS = {
    date: { month: "short", day: "numeric", year: "numeric" },
    long_date: { month: "long", day: "numeric", year: "numeric" },
    day: { month: "short", day: "numeric" },
    date_time: { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false },
  }

  connect() {
    const at = new Date(this.element.getAttribute("datetime"))
    if (isNaN(at.getTime())) return

    // The exact moment, whatever the text says — a relative time is unreadable
    // when the question is which day, and a short date has no year in it.
    this.element.title = this.format(at, "date_time")
    if (this.formatValue !== "relative") this.element.textContent = this.format(at, this.formatValue)
  }

  format(at, name) {
    const parts = this.constructor.PARTS[name]
    if (!parts) return this.element.textContent

    return new Intl.DateTimeFormat("en-US", parts).format(at)
  }
}
